import { render } from "./EndTimeView.vue?vue&type=template&id=15fac0e1&scoped=true"
import script from "./EndTimeView.vue?vue&type=script&lang=js"
export * from "./EndTimeView.vue?vue&type=script&lang=js"

import "./EndTimeView.vue?vue&type=style&index=0&id=15fac0e1&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src821934687/src/cuco-prova-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15fac0e1"]])

export default __exports__